import script from "./NexgridColorAI.vue?vue&type=script&setup=true&lang=js"
export * from "./NexgridColorAI.vue?vue&type=script&setup=true&lang=js"

import "./NexgridColorAI.vue?vue&type=style&index=0&id=24ec4c77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ec4c77"]])

export default __exports__